module.exports = __webpack_public_path__ + "img/7.6fa95bf4.jpg";